import React from "react"
import ImagePlaceholder from "./ImagePlaceholder"
import PreviewCompatibleImage from "./PreviewCompatibleImage"
import { classNames } from "./utils"

const Team = ({ title, className, teamMembers }) => {
  return (
    <div className={classNames("team", className)}>
      <h2>{title}</h2>
      <div className="team-members">
        {teamMembers.map(({ image, jobTitle, name, description }) => (
          <div className="team-member" key={name}>
            {image ? (
              <PreviewCompatibleImage imageInfo={image} />
            ) : (
              <ImagePlaceholder width="100%" aspectRatio="1/1" />
            )}
            <span className="team-member-jobtitle">{jobTitle}</span>
            <span className="team-member-name">{name}</span>
            <p>{description}</p>
          </div>
        ))}
      </div>
    </div>
  )
}

export default Team
